'use strict';
const Backbone = require('backbone');
const Moment = require('moment');

module.exports = Backbone.Model.extend({
    defaults: {
        sender: null,
        message: null,
        createdAt: null,
        version: 2
    },

    getTitle: function() {
        throw 'Not Implemented!';
    },

    getSender: function() {
        throw 'Not Implemented!';
    },

    getSubTitle: function() {
        throw 'Not Implemented!';
    },

    getContent: function() {
        throw 'Not Implemented!';
    },

    getCreatedAt: function() {
        return Moment(this.get('createdAt'));
    },

    getEventAt: function() {
        return Moment(this.get('eventAt'));
    },

    getIconClass: function() {
        return null;
    },

    getImageURL: function() {
        return null;
    },

    getLinkURL: function() {
        throw 'Not Implemented!';
    },

    isRead: function() {
        return this.get('read');
    },

    isEditable: function() {
        return true;
    }
}, {
    type: null
});



// WEBPACK FOOTER //
// ./notify/domain/entity/notification/index.js